<template>
  <div class="ContainDiv">
    <h3>安全培训学时证明</h3>
    <table class="data_tbl" cellspacing="0">
      <thead>
        <tr>
          <th style="width: 10%"></th>
          <th style="width: 10%"></th>
          <th style="width: 10%"></th>
          <th style="width: 10%"></th>
          <th style="width: 10%"></th>
          <th style="width: 5%"></th>
          <th style="width: 5%"></th>
          <th style="width: 22%"></th>
          <th style="width: 18%"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colspan="2">姓名</td>
          <td colspan="2">{{ printContent.Name }}</td>
          <td colspan="2">身份证号</td>
          <td colspan="2">{{ printContent.IDCard }}</td>
          <td rowspan="5">
            <img :src="printContent.PhotoUrl" style="width: 95%" alt="照片" />
          </td>
        </tr>
        <tr>
          <td colspan="2">人员类别</td>
          <td colspan="2">{{ printContent.MenTypeName }}</td>
          <td colspan="2">职务</td>
          <td colspan="2">{{ printContent.WorkTypeName }}</td>
        </tr>
        <tr>
          <td colspan="2">工作单位</td>
          <td colspan="6">{{ printContent.WorkSite }}</td>
        </tr>
        <tr>
          <td colspan="2">行业类别</td>
          <td colspan="2">{{ printContent.IndustryInfoName }}</td>
          <td colspan="2">培训类型</td>
          <td colspan="2">{{ printContent.PeriodClass }}</td>
        </tr>
        <tr>
          <td colspan="2">培训时间</td>
          <td colspan="6">
            {{
              printContent.TrainBegDateString + " 至 " + printContent.TrainEndDateString
            }}
          </td>
        </tr>
        <tr>
          <td rowspan="2">线上培训</td>
          <td>应修学时</td>
          <td>已修学时</td>
          <td rowspan="2">线下培训</td>
          <td>应修学时</td>
          <td colspan="2">已修学时</td>
          <td rowspan="2">总学时</td>
          <td rowspan="2">{{ printContent.SubjectTotalHour }}</td>
        </tr>
        <tr>
          <td>-</td>
          <td>-</td>
          <td>{{ printContent.SubjectTotalHour }}</td>
          <td colspan="2">
            {{ printContent.AttendanceDays == 0 ? 0 : printContent.SubjectStudyHour }}
          </td>
        </tr>
        <tr>
          <td colspan="9"></td>
        </tr>
        <tr>
          <td colspan="9">培训学时明细</td>
        </tr>
        <tr>
          <td>序号</td>
          <td colspan="4">课程名称</td>
          <td colspan="2">培训方式</td>
          <td>学时</td>
          <td>备注</td>
        </tr>
        <tr
          v-if="trainContent && trainContent.length > 0"
          v-for="subjectContent in trainContent"
        >
          <td>{{ subjectContent.split("|")[0] }}</td>
          <td colspan="4">{{ subjectContent.split("|")[1] }}</td>
          <td colspan="2">{{ subjectContent.split("|")[2] }}</td>
          <td>{{ subjectContent.split("|")[3] }}</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="9">
            <p class="content_line1">
              {{
                printContent.AttendanceDays == 0
                  ? "未完成规定的培训内容和学时，特此证明。"
                  : "已完成规定的培训内容和学时，特此证明。"
              }}
            </p>
            <p class="content_line2">生产经营单位或培训机构：（盖章）</p>
            <p class="content_line2">
              &emsp;&emsp;日期：{{ printContent.TrainEndDateString }}
            </p>
            <p
              v-if="printContent.WorkTypeName && printContent.WorkTypeName.length > 14"
              class="seal_image"
              :style="'top:' + (382 + printContent.SubjectCount * 27) + 'px'"
            >
              <img
                v-if="printContent.SealImage"
                :src="printContent.SealImage"
                alt="公章"
              />
            </p>
            <p
              v-else
              class="seal_image"
              :style="'top:' + (366 + printContent.SubjectCount * 27) + 'px'"
            >
              <img
                v-if="printContent.SealImage"
                :src="printContent.SealImage"
                alt="公章"
              />
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <p class="tip_content">
      备注：按照《关于大力推广和规范网络在线安全培训工作的实施意见》（晋应急发〔2021〕44号）有关要求进行线上学时认定。如无线上培训，仅需按实际填写线下培训，并按有关文件要求执行。
    </p>
  </div>
</template>

<script>
export default {
  name: "PrintProve",
  data() {
    return {
      printContent: {},
      trainContent: [],
    };
  },
  methods: {
    BackToIndex() {
      this.$router.push("/");
    },
  },
  activated() {
    let cacheData = localStorage.getItem("printProveCacheData");
    if (!cacheData) {
      this.$router.push("/");
      return;
    }
    this.printContent = JSON.parse(cacheData);
    if (this.printContent.StudyContent) {
      this.trainContent = this.printContent.StudyContent.split(",");
    }
    //console.log(this.printContent);
    window.print();
    //自动关闭窗口页面
    setTimeout(() => {
      window.close();
    }, 300);
  },
  created() {},
};
</script>
<style scoped>
h3 {
  font-size: 24px;
  margin-top: 20px;
  margin-bottom: 10px;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}

p {
  margin: 0 0 10px;
}

.ContainDiv {
  font-size: 12px;
  line-height: 1.42857143;
  font-family: sans-serif;
  -webkit-text-size-adjust: 100%;
  width: 100%;
  text-align: center;
}

.p_title {
  text-align: left;
  margin-left: 1%;
}

.data_tbl {
  margin: 0 1% 0 1%;
  border-collapse: collapse;
  width: 98%;
  border-top: 1px solid #666;
  border-left: 1px solid #666;
}

.data_tbl td {
  border-bottom: 1px solid #666;
  border-right: 1px solid #666;
  height: 22px;
  line-height: 22px;
  word-break: break-all;
  padding: 2px;
  font-size: 10px;
  width: auto;
  text-align: center;
}

.content_line1 {
  margin-top: 30px;
  font-size: 18px;
  margin-bottom: 30px;
}

.content_line2 {
  text-align: left;
  margin-left: 70%;
  margin-top: 10px;
}

.tip_content {
  margin: 0 1% 0 1%;
  margin-top: 10px;
  text-align: left;
}

.seal_image {
  position: absolute;
  left: 530px;
}

.seal_image img {
  width: 160px;
}
</style>



// WEBPACK FOOTER //
// src/views/PrintProve.vue